/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import EmployeeContractsList from 'domain/people/employee/contracts/List';
import { createRoute, Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { ProtectedRoute } from 'framework/authorization';
import {
  CREATE_EMPLOYEE_CONTRACT,
  READ_EMPLOYEE_CONTRACT,
  READ_EMPLOYEE_CONTRACTS_LIST,
  UPDATE_EMPLOYEE_CONTRACT,
} from 'domain/people/employee/contracts/shared/employeeContractsService';
import CreateEmployeeContract from 'domain/people/employee/contracts/createupdate/Create';
import EmployeeContractsContext from 'domain/people/employee/contracts/EmployeeContractsContext';
import UpdateEmployeeContract from 'domain/people/employee/contracts/createupdate/Update';
import ViewEmployeeContract from 'domain/people/employee/contracts/Show';

const useEmployeeContractRoute = () => {
  return createRoute({
    singleEntityRoute: `/:contractId`,
    listRoute: `/contracts`,
  });
};

const EmployeeContractsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { singleEntityRoute, listRoute, updateRoute, createRoute: createEmployeeContract } = useEmployeeContractRoute();

  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <ProtectedRoute permissionToCheck={READ_EMPLOYEE_CONTRACTS_LIST}>
            <EmployeeContractsList />
          </ProtectedRoute>
        }
      />

      <Route
        path={createEmployeeContract}
        element={
          <ProtectedRoute path={createEmployeeContract} permissionToCheck={CREATE_EMPLOYEE_CONTRACT}>
            <CreateEmployeeContract />
          </ProtectedRoute>
        }
      />

      <Route
        path={updateRoute}
        element={
          <EmployeeContractsContext permissionToCheck={UPDATE_EMPLOYEE_CONTRACT}>
            <UpdateEmployeeContract />
          </EmployeeContractsContext>
        }
      />

      <Route
        path={singleEntityRoute}
        element={
          <EmployeeContractsContext permissionToCheck={READ_EMPLOYEE_CONTRACT}>
            <ViewEmployeeContract />
          </EmployeeContractsContext>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default EmployeeContractsRouter;
